import React, { FC } from 'react';
import TextComponentDecider from '../../TextComponentDecider';
import { TTextFieldGuard } from '../types/overlayCarouselPopup.types';

const TextFieldGuard: FC<TTextFieldGuard> = ({ field, richText }) => {
  if (!field) return null;
  return <TextComponentDecider type={richText ? 'RichText' : 'Text'} field={field} />;
};

export default TextFieldGuard;
